import React from 'react';
import { Navigate } from 'react-router';
import { useHasPermission } from '../hooks/use-has-permission';
import { APP_ROUTE } from '@/app/app.route.constant';
import type { Permission } from '../constants/permissions.constant';

interface PermissionRouteGuardProps {
  permission: Permission | Permission[];
  children: React.ReactNode;
}

export function PermissionRouteGuard({
  permission,
  children,
}: PermissionRouteGuardProps) {
  const hasPermission = useHasPermission(permission);

  if (!hasPermission) {
    return <Navigate to={APP_ROUTE.ERROR.FORBIDDEN.getHref()} replace />;
  }

  return children;
}
